if (!customElements.get("features-grid-swiper")) {
  class FeaturesGridSwiper extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.sliderInstance = null;
      this.mql = window.matchMedia("(max-width: 990px)");
    }

    connectedCallback() {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          requestAnimationFrame(() => this.init());
        });
      } else {
        requestAnimationFrame(() => this.init());
      }

      this.mql.addEventListener("change", () => this.init());
      window.addEventListener("resize", () => this.handleResize());
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.mql.matches) {
          this.equalizeCardHeights();
        }
      }, 100);
    }

    init() {
      if (this.mql.matches) {
        this.initSlider();
        setTimeout(() => this.equalizeCardHeights(), 50);
      } else {
        this.resetCardHeights();
        this.destroySlider();
      }
    }

    equalizeCardHeights() {
      const columns = this.querySelectorAll(".features-grid__swiper-column");
      if (!columns.length) return;

      const allCards = this.querySelectorAll(".features-grid__card");
      allCards.forEach((card) => (card.style.height = "auto"));

      void this.offsetHeight;

      const maxCards = Math.max(
        ...Array.from(columns).map(
          (col) => col.querySelectorAll(".features-grid__card").length,
        ),
      );

      for (let rowIndex = 0; rowIndex < maxCards; rowIndex++) {
        let maxHeight = 0;

        columns.forEach((column) => {
          const cards = column.querySelectorAll(".features-grid__card");
          if (cards[rowIndex]) {
            const height = cards[rowIndex].offsetHeight;
            if (height > maxHeight) maxHeight = height;
          }
        });

        if (maxHeight > 0) {
          columns.forEach((column) => {
            const cards = column.querySelectorAll(".features-grid__card");
            if (cards[rowIndex]) {
              cards[rowIndex].style.height = `${maxHeight}px`;
            }
          });
        }
      }
    }

    resetCardHeights() {
      const cards = this.querySelectorAll(".features-grid__card");
      cards.forEach((card) => (card.style.height = ""));
    }

    initSlider() {
      if (this.sliderInstance) return;

      const swiperContainer = this.querySelector(".features-grid__swiper");
      const pagination = this.querySelector(".features-grid__pagination");

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Pagination],
        slidesPerView: "auto",
        spaceBetween: 6,
        pagination: {
          el: pagination,
          clickable: true,
          type: "bullets",
        },
        threshold: 2,
      };

      this.sliderInstance = new window.FoxTheme.Carousel(
        swiperContainer,
        sliderOptions,
      );
      this.sliderInstance.init();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const target = e.target;
          const index = Number(target.dataset.index);
          const slideIndex = Math.floor(index / 2);

          if (this.sliderInstance.slider) {
            this.sliderInstance.slider.slideTo(slideIndex);
          }
        });
      }
    }

    destroySlider() {
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = null;
      }
    }
  }
  customElements.define("features-grid-swiper", FeaturesGridSwiper);
}
